import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { MdLockOutline, MdPersonOutline } from 'react-icons/md'

import { userManager } from '@/Core/Managers'
import { SettingsShell } from '@/Ship/Components/UI/SettingsShell/SettingsShell'
import { UserAvatarContent } from '@/Ship/Components/UI/UserPhoto/UserAvatarContent'
import {
    formatPhone,
    resolveInitials,
    resolveRoleLabel,
} from '@/Ship/Templates/Layouts/Components/UserProfileBlock/UserProfileBlock'

import { ChangePassword } from './ChangePassword'
import { PersonalInfo } from './PersonalInfo'

interface UserProfileProps {
    title?: string
}

/**
 * Сторінка «Мій профіль»: оболонка налаштувань (SettingsShell) із фото, ПІБ, роллю
 * і телефоном у шапці та розділами «Особиста інформація» і «Змінити пароль».
 */
export const UserProfile = observer(({ title }: UserProfileProps) => {
    if (title) document.title = title

    const { t } = useTranslation()
    const tp = (key: string) => t(key, { ns: 'Setting.Profile' })

    const user = (userManager.user ?? {}) as Record<string, any>
    const fullName: string = user['fullName'] || ''
    const subtitle = [resolveRoleLabel(user['roles']), user['phone'] ? formatPhone(String(user['phone'])) : '']
        .filter(Boolean)
        .join(' · ')

    return (
        <SettingsShell
            title={fullName || tp('My profile')}
            subtitle={subtitle}
            ariaLabel={tp('My profile')}
            avatar={<UserAvatarContent photo={user['photo']} initials={resolveInitials(fullName)} />}
            sections={[
                {
                    key: 'PersonalInfo',
                    label: tp('Personal information'),
                    icon: <MdPersonOutline />,
                    content: <PersonalInfo />,
                },
                {
                    key: 'ChangePassword',
                    label: tp('Change password'),
                    icon: <MdLockOutline />,
                    content: <ChangePassword />,
                },
            ]}
        />
    )
})
